<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">Retention Period</span>
      <button *ngIf="allowCancel"
        mat-icon-button
        class="mat-icon-button white-fg"
        (click)="dialogRef.close()"
        aria-label="Close dialog"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0">
    <form [formGroup]="form" fxLayout="column" fxFlex>

      <mat-form-field *ngIf="this.showApplyTo">
        <mat-label>Apply Retention to</mat-label>
        <mat-select
          id="applyTo"
          class="form-control"
          formControlName="applyTo"
          name="applyTo"
          [setFocus]="true"
        >
          <mat-option [value]="1">All selected cases</mat-option>
          <mat-option [value]="2">Selected cases without a retention period specified</mat-option>
        </mat-select>        
      </mat-form-field>      
      <validation-errors [control]="form.get('applyTo')" ></validation-errors>

      <mat-form-field>
        <mat-label>Retention Period</mat-label>
        <mat-select
          id="retentionPeriod"
          class="form-control"
          formControlName="retentionPeriod"
          name="retentionPeriod"
          [setFocus]="!this.showApplyTo"
          required
        >
          <mat-option
            *ngFor="let retention of this.retentionService.listOfRetentions"
            [value]="retention.id"
          >
            {{ retention.name }}
          </mat-option>
        </mat-select>                
      </mat-form-field>
      <validation-errors [control]="form.get('retentionPeriod')" ></validation-errors>
    </form>
  </div>
  <div
    mat-dialog-actions
    class="m-0 p-24"
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <div>
      <button
        mat-raised-button
        type="submit"
        [disabled]="!form.valid || form.pristine"
        (click)="confirmSubmit()"
        class="save-button mat-accent"
        aria-label="CONFIRM"
      >
        CONFIRM
      </button>
    </div>
  </div>
</div>
